"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("isomorphic-fetch");
var _reactIntl = require("react-intl");
var React = _interopRequireWildcard(require("react"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Popover = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Popover"));
var _ButtonLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/ButtonLink"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LoggedPanelLinks = _interopRequireDefault(require("../SidePanel/LoggedPanel/LoggedPanelLinks"));
var _ProfileImage4 = _interopRequireDefault(require("../components/ProfileImage"));
var _useGetUser = _interopRequireDefault(require("../components/useGetUser"));
var _events = require("../consts/events");
var _context = require("../../../services/log/context");
var _Media = _interopRequireDefault(require("../components/Media"));
var _jsxRuntime = require("react/jsx-runtime");
var _ProfileImage, _ProfileImage2, _ProfileImage3;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StyledContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "AccountButton__StyledContainer",
  componentId: "sc-o1u9tu-0"
})(["button{> *:first-child{> *:nth-child(2){position:relative;}}}"]);
const AccountButton = ({
  togglePanel
}) => {
  var _user$displayName, _user$email;
  const user = (0, _useGetUser.default)();
  const {
    log
  } = (0, _context.useLog)();
  const intl = (0, _reactIntl.useIntl)();
  const name = (_user$displayName = user === null || user === void 0 ? void 0 : user.displayName) !== null && _user$displayName !== void 0 ? _user$displayName : "";
  const email = (_user$email = user === null || user === void 0 ? void 0 : user.email) !== null && _user$email !== void 0 ? _user$email : "";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Media.default, {
      greaterThanOrEqual: "tablet",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Popover.default, {
        dataTest: "TopNav-AccountMenuPopover",
        placement: "top-start",
        offset: {
          top: 10
        },
        fixed: true,
        content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoggedPanelLinks.default, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
            flex: true,
            align: "center",
            spacing: "XXSmall",
            children: [_ProfileImage || (_ProfileImage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileImage4.default, {
              imgSize: "tiny"
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              size: "small",
              type: "secondary",
              children: email
            })]
          })
        }),
        labelClose: intl.formatMessage({
          id: "orbit.button_close"
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContainer, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
            compact: true,
            dataTest: "TopNav-AccountMenuButton",
            onClick: () => log(_events.VISIT_ACCOUNT_MENU, {}),
            type: "secondary",
            iconRight: _ProfileImage2 || (_ProfileImage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileImage4.default, {
              enableNotificationDot: true
            })),
            children: name
          })
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Media.default, {
      lessThan: "tablet",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
        compact: true,
        dataTest: "TopNav-AccountMenuButton",
        onClick: togglePanel,
        type: "secondary",
        iconRight: _ProfileImage3 || (_ProfileImage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileImage4.default, {
          enableNotificationDot: true
        }))
      })
    })]
  });
};
var _default = AccountButton;
exports.default = _default;